'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _client = require('./client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Experiences = function (_Client) {
  (0, _inherits3.default)(Experiences, _Client);

  function Experiences(opts) {
    (0, _classCallCheck3.default)(this, Experiences);

    var options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API';

    return (0, _possibleConstructorReturn3.default)(this, (Experiences.__proto__ || Object.getPrototypeOf(Experiences)).call(this, options));
  }

  (0, _createClass3.default)(Experiences, [{
    key: 'get',
    value: function get(organization) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences', options);
    }
  }, {
    key: 'post',
    value: function post(organization) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences', (0, _extends3.default)({}, options, {
        method: 'POST'
      }));
    }
  }, {
    key: 'getConversionsByBaseAndAmount',
    value: function getConversionsByBaseAndAmount(organization, base, amount) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/conversions/' + encodeURIComponent(base) + '/' + encodeURIComponent(amount), options);
    }
  }, {
    key: 'getItems',
    value: function getItems(organization) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/items', options);
    }
  }, {
    key: 'getItemsByNumber',
    value: function getItemsByNumber(organization, number) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/items/' + encodeURIComponent(number), options);
    }
  }, {
    key: 'postQueryAndBuilders',
    value: function postQueryAndBuilders(organization) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/query/builders', (0, _extends3.default)({}, options, {
        method: 'POST'
      }));
    }
  }, {
    key: 'getVersions',
    value: function getVersions(organization) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/versions', options);
    }
  }, {
    key: 'getCurrencyAndFormatsByExperienceKey',
    value: function getCurrencyAndFormatsByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/currency/formats', options);
    }
  }, {
    key: 'putCurrencyAndFormatsByExperienceKey',
    value: function putCurrencyAndFormatsByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/currency/formats', (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'getLocalAndItemsByExperienceKey',
    value: function getLocalAndItemsByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/local/items', options);
    }
  }, {
    key: 'getLogisticsAndSummaryByExperienceKey',
    value: function getLogisticsAndSummaryByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/logistics/summary', options);
    }
  }, {
    key: 'getMarginsByExperienceKey',
    value: function getMarginsByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/margins', options);
    }
  }, {
    key: 'postMarginsByExperienceKey',
    value: function postMarginsByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/margins', (0, _extends3.default)({}, options, {
        method: 'POST'
      }));
    }
  }, {
    key: 'getMarginsAndVersionsByExperienceKey',
    value: function getMarginsAndVersionsByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/margins/versions', options);
    }
  }, {
    key: 'getMarginsByExperienceKeyAndKey',
    value: function getMarginsByExperienceKeyAndKey(organization, experienceKey, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/margins/' + encodeURIComponent(key), options);
    }
  }, {
    key: 'putMarginsByExperienceKeyAndKey',
    value: function putMarginsByExperienceKeyAndKey(organization, experienceKey, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/margins/' + encodeURIComponent(key), (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'deleteMarginsByExperienceKeyAndKey',
    value: function deleteMarginsByExperienceKeyAndKey(organization, experienceKey, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/margins/' + encodeURIComponent(key), (0, _extends3.default)({}, options, {
        method: 'DELETE'
      }));
    }
  }, {
    key: 'getPaymentMethodTypesByExperienceKey',
    value: function getPaymentMethodTypesByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/payment-method-types', options);
    }
  }, {
    key: 'getPaymentAndMethodAndRulesByExperienceKey',
    value: function getPaymentAndMethodAndRulesByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/payment/method/rules', options);
    }
  }, {
    key: 'putPaymentAndMethodAndRulesByExperienceKey',
    value: function putPaymentAndMethodAndRulesByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/payment/method/rules', (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'getPriceAndBooksByExperienceKey',
    value: function getPriceAndBooksByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/price/books', options);
    }
  }, {
    key: 'postPriceAndBooksByExperienceKey',
    value: function postPriceAndBooksByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/price/books', (0, _extends3.default)({}, options, {
        method: 'POST'
      }));
    }
  }, {
    key: 'putPriceAndBooksByExperienceKey',
    value: function putPriceAndBooksByExperienceKey(organization, experienceKey) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/price/books', (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'getPriceAndBooksByExperienceKeyAndKey',
    value: function getPriceAndBooksByExperienceKeyAndKey(organization, experienceKey, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/price/books/' + encodeURIComponent(key), options);
    }
  }, {
    key: 'deletePriceAndBooksByExperienceKeyAndKey',
    value: function deletePriceAndBooksByExperienceKeyAndKey(organization, experienceKey, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(experienceKey) + '/price/books/' + encodeURIComponent(key), (0, _extends3.default)({}, options, {
        method: 'DELETE'
      }));
    }
  }, {
    key: 'getByKey',
    value: function getByKey(organization, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key), options);
    }
  }, {
    key: 'putByKey',
    value: function putByKey(organization, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key), (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'deleteByKey',
    value: function deleteByKey(organization, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key), (0, _extends3.default)({}, options, {
        method: 'DELETE'
      }));
    }
  }, {
    key: 'postCloneByKey',
    value: function postCloneByKey(organization, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key) + '/clone', (0, _extends3.default)({}, options, {
        method: 'POST'
      }));
    }
  }, {
    key: 'getCloneByKeyAndId',
    value: function getCloneByKeyAndId(organization, key, id) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key) + '/clone/' + encodeURIComponent(id), options);
    }
  }, {
    key: 'getItemsAndPriceByKeyAndNumber',
    value: function getItemsAndPriceByKeyAndNumber(organization, key, number) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key) + '/items/' + encodeURIComponent(number) + '/price', options);
    }
  }, {
    key: 'getPricingByKey',
    value: function getPricingByKey(organization, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key) + '/pricing', options);
    }
  }, {
    key: 'putPricingByKey',
    value: function putPricingByKey(organization, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key) + '/pricing', (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'getPromotionsAndAvailableByKey',
    value: function getPromotionsAndAvailableByKey(organization, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key) + '/promotions/available', options);
    }
  }, {
    key: 'putStatusByKey',
    value: function putStatusByKey(organization, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/' + encodeURIComponent(organization) + '/experiences/' + encodeURIComponent(key) + '/status', (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }]);
  return Experiences;
}(_client2.default);

exports.default = Experiences;